import React from 'react';
import { ArrowRightIcon, ScaleIcon } from 'lucide-react';
import { Eyebrow, Section } from './Shared';
import { LeafSpray, WaterRipple } from './Decor';
import { costs } from '../data/pack';
export function CostComparison() {
  return <Section data-id="element-14" data-mp="26vdue8fyriun">
      <div className="mx-auto mb-10 max-w-2xl text-center" data-id="element-15" data-mp="26v46qrie5ns4">
        <Eyebrow className="flex items-center justify-center gap-2" data-id="element-16" data-mp="21wu7o5tjq318">
          <ScaleIcon className="h-4 w-4" aria-hidden="true" data-id="element-17" data-mp="2yls3lrd186zz" />
          El otro costo
        </Eyebrow>
        <h2 className="mt-3 font-title text-2xl leading-tight text-brand-jadeDeep md:text-4xl" data-id="element-18" data-mp="2ukq2t63gvmvw">
          ¿Cuánto cuesta no tenerlo?
        </h2>
        <div className="double-rule mx-auto mt-5 w-24" aria-hidden="true" data-id="element-19" data-mp="2pjsk8sejoqtv" />
      </div>

      <div className="mx-auto max-w-4xl" data-id="element-20" data-mp="2klhasis5wic6">
        <div className="mb-3 hidden grid-cols-2 gap-6 px-5 font-title text-xs uppercase tracking-[0.2em] md:grid" data-id="element-21" data-mp="2komz3vsyvg6u">
          <span className="text-brand-muted" data-id="element-22" data-mp="197djjkcyl8at">Sin Feng Shui Negocios™</span>
          <span className="text-brand-cinnabar" data-id="element-23" data-mp="1996o8u40hig6">Consecuencia</span>
        </div>
        <ul className="space-y-2.5" data-id="element-24" data-mp="2lbapo54xqjdj">
          {costs.map(([without, result]) => <li key={without} className="paper-panel grid gap-2 p-4 md:grid-cols-2 md:gap-6 md:p-5" data-id="element-25" data-mp="2pbcp07n770pn">
              <p className="font-title text-sm text-brand-ink md:text-base" data-id="element-26" data-mp="2bbjsfvozpq9r">{without}</p>
              <p className="flex items-start gap-2 font-serif text-sm text-brand-inkLight md:text-base" data-id="element-27" data-mp="2gawnh3q0m3nf">
                <ArrowRightIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-brand-cinnabar md:hidden" aria-hidden="true" data-id="element-28" data-mp="21lqqznikarj8" />
                {result}
              </p>
            </li>)}
        </ul>
      </div>

      <figure className="relative mx-auto mt-14 max-w-3xl overflow-hidden border border-brand-jade/40 bg-brand-jadeMist p-8 text-center md:p-10" data-id="element-29" data-mp="1sn6dr1vrta2e">
        <LeafSpray className="pointer-events-none absolute -bottom-6 -left-6 hidden h-40 w-40 text-brand-jade/15 md:block" data-id="element-30" data-mp="1xiu25f2fhz6u" />
        <blockquote className="relative font-serif text-lg font-medium italic leading-relaxed text-brand-jadeDeep md:text-2xl" data-id="element-31" data-mp="1nnk1aunrnxun">
          “Quien aprende a observar su espacio deja de cambiar cosas al azar. Primero detecta. Después corrige. Y recién
          entonces activa.”
        </blockquote>
        <WaterRipple className="relative mx-auto mt-6 h-5 w-32 text-brand-water/60" data-id="element-32" data-mp="uscet7hop4g5" />
      </figure>

      <p className="mx-auto mt-10 max-w-3xl text-center font-title text-lg leading-snug text-brand-wood md:text-2xl" data-id="element-33" data-mp="pu1835mora25">
        Tu próxima renovación empieza con criterio, no con improvisación.
      </p>
    </Section>;
}